import { lazy } from 'react';

export const PoliceLazy = lazy(() => import('./Police'));
